module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    staticStyle: {
      "margin-left": "0.5rem !important"
    },
    attrs: {
      "center": ""
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("person")]), _vm._v("Driver Profile Details\n        ")], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-button', {
    staticClass: "me-2",
    attrs: {
      "size": "sm",
      "variant": "outline-light"
    },
    on: {
      "click": _vm.editDriver
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("edit")]), _vm._v("Edit\n          ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-light"
    },
    on: {
      "click": _vm.printDriverInfo
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("print")]), _vm._v("Print\n          ")], 1)], 1)], 1), _vm._v(" "), (_vm.errorMessage) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": "",
      "dismissible": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.driver) ? _c('b-card', {
    staticClass: "formCard mt-3"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-md-3 text-center"
  }, [_c('div', {
    staticClass: "driver-avatar-container"
  }, [_c('img', {
    staticClass: "driver-avatar",
    attrs: {
      "src": _vm.driver.photo || '/assets/default-avatar.png',
      "alt": "Driver Photo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "status-badge",
    class: _vm.getStatusClass(_vm.driver.isDriverActive)
  }, [_vm._v("\n                  " + _vm._s(_vm.getStatusText(_vm.driver.isDriverActive)) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "driver-name"
  }, [_vm._v(_vm._s(_vm.driver.driverName))]), _vm._v(" "), _c('p', {
    staticClass: "driver-id text-muted"
  }, [_vm._v("Driver ID: " + _vm._s(_vm.driver.driverId))]), _vm._v(" "), _c('div', {
    staticClass: "driver-badges"
  }, [_c('b-badge', {
    staticClass: "me-2",
    attrs: {
      "variant": _vm.driver.driverType === '1' ? 'success' : 'warning'
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.driver.driverType === '1' ? 'Permanent' : 'Temporary') + "\n                ")]), _vm._v(" "), _c('b-badge', {
    staticClass: "me-2",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.getLicenseClass()) + "\n                ")]), _vm._v(" "), _c('b-badge', {
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.driver.driverLocation || 'N/A') + "\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "quick-stats"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('md-icon', {
    staticClass: "text-primary",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("schedule")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExperienceYears()) + " Years")])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('md-icon', {
    staticClass: "text-success",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("local_shipping")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.driver.driverVehicleNumber || 'Not Assigned'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('md-icon', {
    staticClass: "text-info",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("phone")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.driver.driverContact || 'N/A'))])], 1)])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.driver) ? _c('b-card', {
    staticClass: "formCard mt-3"
  }, [_c('b-card-text', [_c('b-tabs', {
    attrs: {
      "content-class": "mt-3",
      "fill": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Personal Information",
      "active": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-primary me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("person")]), _vm._v("Basic Information\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.personalInfoItems,
      "fields": _vm.personalInfoFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-success me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("credit_card")]), _vm._v("Identity Documents\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.identityInfoItems,
      "fields": _vm.identityInfoFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1)])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "License Details"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-warning me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("credit_card")]), _vm._v("License Information\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.licenseInfoItems,
      "fields": _vm.licenseInfoFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-danger me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("warning")]), _vm._v("License Status\n                  ")], 1), _vm._v(" "), _c('div', {
    staticClass: "license-status-card"
  }, [_c('div', {
    staticClass: "status-item"
  }, [_c('strong', [_vm._v("Status:")]), _vm._v(" "), _c('b-badge', {
    attrs: {
      "variant": _vm.getLicenseStatusVariant()
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.getLicenseStatusText()) + "\n                      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "status-item"
  }, [_c('strong', [_vm._v("Days Remaining:")]), _vm._v(" "), _c('span', {
    class: _vm.getDaysRemainingClass()
  }, [_vm._v("\n                        " + _vm._s(_vm.getDaysRemaining()) + " days\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "status-item"
  }, [_c('strong', [_vm._v("Last Updated:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.getLicenseValidUntil())))])])])])]), _vm._v(" "), (_vm.driver.driver_license_coverages && _vm.driver.driver_license_coverages.length) ? _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-info me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("category")]), _vm._v("License Coverages\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.licenseCoverageItems,
      "fields": _vm.licenseCoverageFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.getLicenseImage()) ? _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-warning me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("image")]), _vm._v("License Image\n                  ")], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "license-image",
    staticStyle: {
      "max-width": "400px",
      "max-height": "300px",
      "border": "1px solid #ddd",
      "border-radius": "8px"
    },
    attrs: {
      "src": _vm.getLicenseImage(),
      "alt": "Driver License"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.driver.driver_license_transactions && _vm.driver.driver_license_transactions.length) ? _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-secondary me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("history")]), _vm._v("License Transactions\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.licenseTransactionItems,
      "fields": _vm.licenseTransactionFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Employment Details"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-info me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("work")]), _vm._v("Employment Information\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.employmentInfoItems,
      "fields": _vm.employmentInfoFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-secondary me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("local_shipping")]), _vm._v("Vehicle Assignment\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.vehicleInfoItems,
      "fields": _vm.vehicleInfoFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1)])]), _vm._v(" "), (_vm.driver.driver_bio_info && _vm.driver.driver_bio_info.length) ? _c('b-tab', {
    attrs: {
      "title": "Bio Information"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-primary me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("person")]), _vm._v("Personal Details\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.bioInfoItems,
      "fields": _vm.bioInfoFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-success me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("location_on")]), _vm._v("Address Information\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.addressInfoItems,
      "fields": _vm.addressInfoFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Documents"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('h5', {
    staticClass: "section-title mb-0"
  }, [_c('md-icon', {
    staticClass: "text-primary me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("folder")]), _vm._v("Uploaded Documents\n                    ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("upload")]), _vm._v("Upload New Document\n                    ")], 1)], 1), _vm._v(" "), _c('b-accordion', [_c('b-accordion-item', {
    attrs: {
      "title": "License Documents",
      "header-class": "bg-primary text-white"
    }
  }, [_c('b-row', _vm._l((_vm.getDocumentsByType('license')), function(doc, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "4"
      }
    }, [_c('b-card', {
      staticClass: "document-card mb-3"
    }, [_c('div', {
      staticClass: "document-icon"
    }, [_c('md-icon', {
      staticClass: "text-danger",
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("description")])], 1), _vm._v(" "), _c('div', {
      staticClass: "document-info"
    }, [_c('h6', [_vm._v(_vm._s(doc.name))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted mb-1"
    }, [_vm._v(_vm._s(doc.type))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted mb-1 small"
    }, [_vm._v(_vm._s(doc.description))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatDate(doc.uploadDate)))]), _vm._v(" "), _c('b-badge', {
      staticClass: "mt-1",
      attrs: {
        "variant": doc.status === 'Active' ? 'success' : doc.status === 'Completed' ? 'info' : 'warning'
      }
    }, [_vm._v("\n                                " + _vm._s(doc.status) + "\n                              ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "document-actions mt-2"
    }, [_c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function($event) {
          _vm.viewDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("visibility")])], 1), _vm._v(" "), _c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.downloadDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("download")])], 1), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("delete")])], 1)], 1)])], 1)
  }))], 1), _vm._v(" "), _c('b-accordion-item', {
    attrs: {
      "title": "Identity Documents",
      "header-class": "bg-success text-white"
    }
  }, [_c('b-row', _vm._l((_vm.getDocumentsByType('identity')), function(doc, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "4"
      }
    }, [_c('b-card', {
      staticClass: "document-card mb-3"
    }, [_c('div', {
      staticClass: "document-icon"
    }, [_c('md-icon', {
      staticClass: "text-info",
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("description")])], 1), _vm._v(" "), _c('div', {
      staticClass: "document-info"
    }, [_c('h6', [_vm._v(_vm._s(doc.name))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted mb-1"
    }, [_vm._v(_vm._s(doc.type))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted mb-1 small"
    }, [_vm._v(_vm._s(doc.description))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatDate(doc.uploadDate)))]), _vm._v(" "), _c('b-badge', {
      staticClass: "mt-1",
      attrs: {
        "variant": doc.status === 'Active' ? 'success' : doc.status === 'Completed' ? 'info' : 'warning'
      }
    }, [_vm._v("\n                                " + _vm._s(doc.status) + "\n                              ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "document-actions mt-2"
    }, [_c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function($event) {
          _vm.viewDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("visibility")])], 1), _vm._v(" "), _c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.downloadDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("download")])], 1), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("delete")])], 1)], 1)])], 1)
  }))], 1), _vm._v(" "), _c('b-accordion-item', {
    attrs: {
      "title": "Medical Documents",
      "header-class": "bg-warning text-dark"
    }
  }, [_c('b-row', _vm._l((_vm.getDocumentsByType('medical')), function(doc, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "4"
      }
    }, [_c('b-card', {
      staticClass: "document-card mb-3"
    }, [_c('div', {
      staticClass: "document-icon"
    }, [_c('md-icon', {
      staticClass: "text-success",
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("description")])], 1), _vm._v(" "), _c('div', {
      staticClass: "document-info"
    }, [_c('h6', [_vm._v(_vm._s(doc.name))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted mb-1"
    }, [_vm._v(_vm._s(doc.type))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted mb-1 small"
    }, [_vm._v(_vm._s(doc.description))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatDate(doc.uploadDate)))]), _vm._v(" "), _c('b-badge', {
      staticClass: "mt-1",
      attrs: {
        "variant": doc.status === 'Active' ? 'success' : doc.status === 'Completed' ? 'info' : 'warning'
      }
    }, [_vm._v("\n                                " + _vm._s(doc.status) + "\n                              ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "document-actions mt-2"
    }, [_c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function($event) {
          _vm.viewDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("visibility")])], 1), _vm._v(" "), _c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.downloadDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("download")])], 1), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("delete")])], 1)], 1)])], 1)
  }))], 1), _vm._v(" "), _c('b-accordion-item', {
    attrs: {
      "title": "Employment Documents",
      "header-class": "bg-info text-white"
    }
  }, [_c('b-row', _vm._l((_vm.getDocumentsByType('employment')), function(doc, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "4"
      }
    }, [_c('b-card', {
      staticClass: "document-card mb-3"
    }, [_c('div', {
      staticClass: "document-icon"
    }, [_c('md-icon', {
      staticClass: "text-primary",
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("work")])], 1), _vm._v(" "), _c('div', {
      staticClass: "document-info"
    }, [_c('h6', [_vm._v(_vm._s(doc.name))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted mb-1"
    }, [_vm._v(_vm._s(doc.type))]), _vm._v(" "), _c('p', {
      staticClass: "text-muted mb-1 small"
    }, [_vm._v(_vm._s(doc.description))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatDate(doc.uploadDate)))]), _vm._v(" "), _c('b-badge', {
      staticClass: "mt-1",
      attrs: {
        "variant": doc.status === 'Active' ? 'success' : doc.status === 'Completed' ? 'info' : 'warning'
      }
    }, [_vm._v("\n                                " + _vm._s(doc.status) + "\n                              ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "document-actions mt-2"
    }, [_c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function($event) {
          _vm.viewDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("visibility")])], 1), _vm._v(" "), _c('b-button', {
      staticClass: "me-1",
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.downloadDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("download")])], 1), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteDocument(doc)
        }
      }
    }, [_c('md-icon', {
      attrs: {
        "icon": "gear-fill",
        "aria-hidden": "true"
      }
    }, [_vm._v("delete")])], 1)], 1)])], 1)
  }))], 1)], 1)], 1)])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Advanced Details"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-success me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("trending_up")]), _vm._v("Performance Metrics\n                  ")], 1), _vm._v(" "), _c('b-card', {
    staticClass: "metrics-card"
  }, [_c('div', {
    staticClass: "metric-item"
  }, [_c('div', {
    staticClass: "metric-label"
  }, [_vm._v("Safety Score")]), _vm._v(" "), _c('div', {
    staticClass: "metric-value"
  }, [_c('b-progress', {
    attrs: {
      "value": 85,
      "variant": "success",
      "max": 100,
      "show-progress": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "metric-text"
  }, [_vm._v("85%")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "metric-item"
  }, [_c('div', {
    staticClass: "metric-label"
  }, [_vm._v("On-Time Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "metric-value"
  }, [_c('b-progress', {
    attrs: {
      "value": 92,
      "variant": "info",
      "max": 100,
      "show-progress": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "metric-text"
  }, [_vm._v("92%")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "metric-item"
  }, [_c('div', {
    staticClass: "metric-label"
  }, [_vm._v("Fuel Efficiency")]), _vm._v(" "), _c('div', {
    staticClass: "metric-value"
  }, [_c('b-progress', {
    attrs: {
      "value": 78,
      "variant": "warning",
      "max": 100,
      "show-progress": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "metric-text"
  }, [_vm._v("78%")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-secondary me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("settings")]), _vm._v("System Information\n                  ")], 1), _vm._v(" "), _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.systemInfoItems,
      "fields": _vm.systemInfoFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1)])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Raw Data"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_c('md-icon', {
    staticClass: "text-info me-2",
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("code")]), _vm._v("Complete API Response Data\n                  ")], 1), _vm._v(" "), _c('p', {
    staticClass: "text-muted mb-4"
  }, [_vm._v("Displaying every key from the API response for complete data visibility.")]), _vm._v(" "), _c('b-card', {
    staticClass: "mb-4",
    attrs: {
      "header": "Main Driver Information"
    }
  }, [_c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.rawDriverItems,
      "fields": _vm.rawDataFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1), _vm._v(" "), (_vm.driver.driver_license_details && _vm.driver.driver_license_details.length) ? _c('b-card', {
    staticClass: "mb-4",
    attrs: {
      "header": "License Details"
    }
  }, [_c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.rawLicenseDetailsItems,
      "fields": _vm.rawLicenseDetailsFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.driver.driver_license_obj && _vm.driver.driver_license_obj.length) ? _c('b-card', {
    staticClass: "mb-4",
    attrs: {
      "header": "License Object"
    }
  }, [_c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.rawLicenseObjItems,
      "fields": _vm.rawLicenseObjFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.driver.driver_license_coverages && _vm.driver.driver_license_coverages.length) ? _c('b-card', {
    staticClass: "mb-4",
    attrs: {
      "header": "License Coverages"
    }
  }, [_c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.rawLicenseCoveragesItems,
      "fields": _vm.rawLicenseCoveragesFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.driver.driver_license_transactions && _vm.driver.driver_license_transactions.length) ? _c('b-card', {
    staticClass: "mb-4",
    attrs: {
      "header": "License Transactions"
    }
  }, [_c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.rawLicenseTransactionsItems,
      "fields": _vm.rawLicenseTransactionsFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.driver.driver_bio_info && _vm.driver.driver_bio_info.length) ? _c('b-card', {
    staticClass: "mb-4",
    attrs: {
      "header": "Bio Information"
    }
  }, [_c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.rawBioInfoItems,
      "fields": _vm.rawBioInfoFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.driver.driver_bio_img_obj && _vm.driver.driver_bio_img_obj.length) ? _c('b-card', {
    staticClass: "mb-4",
    attrs: {
      "header": "Bio Image Object"
    }
  }, [_c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.rawBioImgItems,
      "fields": _vm.rawBioImgFields,
      "striped": "",
      "hover": "",
      "responsive": ""
    }
  })], 1) : _vm._e()], 1)])])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": _vm.selectedDocument ? _vm.selectedDocument.name : 'Document Viewer',
      "size": "lg",
      "scrollable": "",
      "centered": ""
    },
    model: {
      value: (_vm.showDocumentModal),
      callback: function($$v) {
        _vm.showDocumentModal = $$v
      },
      expression: "showDocumentModal"
    }
  }, [(_vm.selectedDocument) ? _c('div', {
    staticClass: "document-viewer"
  }, [_c('div', {
    staticClass: "document-header mb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h6', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.selectedDocument.name))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mb-1"
  }, [_vm._v(_vm._s(_vm.selectedDocument.type))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted small"
  }, [_vm._v(_vm._s(_vm.selectedDocument.description))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('b-badge', {
    staticClass: "mb-2",
    attrs: {
      "variant": _vm.selectedDocument.status === 'Active' ? 'success' : _vm.selectedDocument.status === 'Completed' ? 'info' : 'warning'
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectedDocument.status) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Uploaded: " + _vm._s(_vm.formatDate(_vm.selectedDocument.uploadDate)))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "document-content"
  }, [_c('div', {
    staticClass: "text-center py-4"
  }, [_c('md-icon', {
    staticClass: "text-muted",
    staticStyle: {
      "font-size": "4rem"
    },
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("description")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-2"
  }, [_vm._v("Document preview not available")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted small"
  }, [_vm._v("This is a placeholder for the actual document content.")])], 1)])]) : _vm._e(), _vm._v(" "), [_c('div', {
    staticClass: "w-100 d-flex justify-content-between"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.showDocumentModal = false
      }
    }
  }, [_vm._v("\n          Close\n        ")]), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "me-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.downloadDocument(_vm.selectedDocument)
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("download")]), _vm._v("\n            Download\n          ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.deleteDocument(_vm.selectedDocument)
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("delete")]), _vm._v("\n            Delete\n          ")], 1)], 1)], 1)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dff3e1a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/driverMaster/DriverDetailView.vue
// module id = 2612
// module chunks = 0